import {
  DEFAULT_MARKETING_VIDEO,
  MARKETING_VIDEO_BASE_URL,
} from './MarketingVideo.constants'
import type {
  MarketingVideoDescriptor,
  VideoSource,
} from './MarketingVideo.types'

// Builds a full asset URL from a filename + base URL. Absolute URLs are
// returned unchanged, so a descriptor can mix relative filenames and absolute
// URLs without special-casing.
export function buildVideoUrl(
  file: string,
  baseUrl: string = MARKETING_VIDEO_BASE_URL,
): string {
  if (/^https?:\/\//.test(file)) {
    return file
  }

  return `${baseUrl}/${file.replace(/^\//, '')}`
}

function getMimeType(file: string): string {
  if (file.endsWith('.webm')) {
    return 'video/webm'
  }

  return 'video/mp4'
}

export function resolveVideoSources(
  descriptor: MarketingVideoDescriptor = DEFAULT_MARKETING_VIDEO,
): VideoSource[] {
  return descriptor.files.map((file) => ({
    src: buildVideoUrl(file),
    type: getMimeType(file),
  }))
}

export function resolveVideoPoster(
  descriptor: MarketingVideoDescriptor = DEFAULT_MARKETING_VIDEO,
): string {
  // Unlike the video files, the poster is bundled with the app (not the R2
  // bucket), so it's already a root-relative path — no base URL to join.
  return descriptor.posterFile
}
